var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('nuxt-link',{staticClass:"rounded-sm bg-vanilla-100 bg-opacity-10 px-1 text-cherry-150",attrs:{"to":_vm.settingsLink}},[_vm._v(_vm._s(_vm.login))])
}
var staticRenderFns = []

export { render, staticRenderFns }